import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {AuthService} from 'src/app/home/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigGuard  {
  constructor(private readonly router: Router, private readonly authService: AuthService) {}
  canActivate(route: ActivatedRouteSnapshot): boolean {
    const apiKey = route.queryParamMap.get('apikey');
    if (apiKey || this.authService.isAuthenticated()) {
      return true;
    }
    return false;
  }
}
